var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakwithEmpathyHonesty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C2.23858 0 0 2.23857 0 5V31.4045C0 34.1659 2.23858 36.4045 5 36.4045H8.49988L13.4999 45L22.4999 36.4045H40C42.7614 36.4045 45 34.1659 45 31.4045V5C45 2.23858 42.7614 0 40 0H5Z",
    fill: "#171C8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4652 12.3521C29.547 10.5493 26.4372 10.5493 24.5196 12.3521L22.9519 13.8256L21.3842 12.3521C19.4661 10.5493 16.3562 10.5493 14.4386 12.3521C12.5205 14.155 12.5205 17.0779 14.4386 18.8803L16.0063 20.3537L22.9519 26.8824L29.898 20.3537L31.4657 18.8803C33.3833 17.0779 33.3833 14.155 31.4652 12.3521Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4652 12.3521C29.547 10.5493 26.4372 10.5493 24.5196 12.3521L22.9519 13.8256L21.3842 12.3521C19.4661 10.5493 16.3562 10.5493 14.4386 12.3521C12.5205 14.155 12.5205 17.0779 14.4386 18.8803L16.0063 20.3537L22.9519 26.8824L29.898 20.3537L31.4657 18.8803C33.3833 17.0779 33.3833 14.155 31.4652 12.3521Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakwithEmpathyHonesty);
export default __webpack_public_path__ + "static/media/SpeakwithEmpathy&Honesty.f1b7417c3aa6858f61ccce4afe6caf7c.svg";
export { ForwardRef as ReactComponent };